export const REMOVE_ROWS_CONFIRMATION_MODAL_I18N_PREFIX = "features.topics.components.remove_rows_confirmation_modal";

export const REMOVE_ROWS_CONFIRMATION_MODAL_I18N_KEYS = {
  modal_title:                    "modal_title",
  paragraph_1:                    "paragraph_1",
  paragraph_2:                    "paragraph_2",
  do_not_show_this_message_again: "do_not_show_this_message_again",
  cancel_button_text:             "cancel_button_text",
  continue_button_text:           "continue_button_text"
};


// WEBPACK FOOTER //
// ./src/features/topics/components/constants/i18n/RemoveRowsConfirmationModali18nConstants.js